import { getParentByClass } from "../../../resources/js/helper/helper";

(function () {
  let currentPage = 1;
  const loadMore = document.getElementById("load-more-stores");
  const storeFilter = document.querySelectorAll(
    ".com-shop-grid__filters .filter"
  );
  const storeSearch = document.querySelectorAll(".shop-grid-shop-search");

  for (let i = 0; i < storeFilter.length; i++) {
    storeFilter[i].addEventListener("click", function (event) {
      let listItem = event.target;

      if (storeFilter[i].classList.contains("open")) {
        storeFilter[i].prepend(listItem);
        filterStores(listItem);
      }

      listItem.closest("ul").classList.toggle("open");
    });
  }

  if (loadMore != null && loadMore != "undefined") {
    loadMore.addEventListener("click", function (event) {
      currentPage++;
      loadMoreStores();
    });
  }

  function filterStores(listItem) {
    const id = listItem.dataset.term;

    jQuery.ajax({
      type: "POST",
      url: globalvars.ajaxurl,
      data: {
        action: "ajax_handler_filter_stores",
        nonce: globalvars.ajax_nonce,
        id: id,
      },
      beforeSend: function beforeSend() {},
      success: function success(data, textStatus, XMLHttpRequest) {
        const response = JSON.parse(data);
        currentPage = 1;

        document.getElementById("stores").innerHTML = response["html"];

        if (response["max"] > currentPage) {
          loadMore.classList.remove("hidden");
        } else {
          loadMore.classList.add("hidden");
        }
      },
      error: function error(MLHttpRequest, textStatus, errorThrown) {
        console.log("filterStores", textStatus, errorThrown);
      },
    });
  }

  function loadMoreStores() {
    const id = document.getElementById("filter").firstElementChild.dataset.term;

    jQuery.ajax({
      type: "POST",
      url: globalvars.ajaxurl,
      data: {
        action: "ajax_handler_load_more_stores",
        nonce: globalvars.ajax_nonce,
        id: id,
        page: currentPage,
      },
      beforeSend: function beforeSend() {},
      success: function success(data, textStatus, XMLHttpRequest) {
        const response = JSON.parse(data);

        document
          .getElementById("stores")
          .insertAdjacentHTML("beforeend", response["html"]);

        if (response["max"] <= currentPage) {
          loadMore.classList.add("hidden");
        }
      },
      error: function error(MLHttpRequest, textStatus, errorThrown) {
        console.log("loadMoreStores", textStatus, errorThrown);
      },
    });
  }

  for (let i = 0; i < storeSearch.length; i++) {
    const domElements = {
      mbSearch: storeSearch[i],
      mbSearchInner: storeSearch[i].querySelector(".shop-search__inner"),
      mbSearchInput: storeSearch[i].querySelector("input"),
      mbSearchPreview: storeSearch[i].querySelector(
        ".shop-grid-shop-search-preview"
      ),
    };

    // Init event listener
    if (domElements.mbSearchInput) {
      domElements.mbSearchInput.addEventListener("input", function (event) {
        event.cancelBubble = true;
        event.preventDefault();
        searchStores(this.value, domElements);
      });

      // hide search results if click outside search elements
      document.addEventListener("click", function (e) {
        const parentContainerInner = getParentByClass(
          e.target,
          "shop-search__inner"
        );

        // return if click inside searchfield
        if (
          !e.target.classList.contains("store-title") &&
          (e.target == domElements.mbSearchInner || parentContainerInner)
        ) {
          return;
        }

        // complete input value after clicking on searchresult
        if (
          e.target.classList.contains("store-title") &&
          parentContainerInner &&
          parentContainerInner == domElements.mbSearchInner
        ) {
          domElements.mbSearchInput.value = e.target.innerHTML;

          if (domElements.mbSearch.dataset.scroll == "true") {
            scrollToID(domElements.mbSearch.dataset.floorplan, -50);
          }
        }

        domElements.mbSearchPreview.innerHTML = "";
      });
    }
  }

  /**
   * filter stores via ajax
   * @param {dom} target
   */
  function searchStores(value, domElements) {
    if (window.xhrSearchStore) {
      // cancel currently running ajax search
      // fallback to error handler!
      window.xhrSearchStore.abort();
      domElements.mbSearchPreview.classList.remove("mb-loading");
    }

    if (value.length >= 1) {
      //   const that = this;
      domElements.mbSearchPreview.classList.add("mb-loading");

      window.xhrSearchStore = jQuery.ajax({
        url: globalvars.ajaxurl,
        type: "POST",
        data: {
          action: "ajax_handler_store_grid_search_stores",
          searchvalue: value,
          nonce: globalvars.ajax_nonce,
        },
        success: function (response) {
          // do something on success
          // console.log(response);
          if (domElements.mbSearchPreview) {
            domElements.mbSearchPreview.classList.remove("mb-loading");
            domElements.mbSearchPreview.innerHTML = response.data;
          }
        },
        error: function () {
          //do something on error
          // console.log("No serach result");
        },
      });
    } else {
      domElements.mbSearchPreview.classList.remove("mb-loading");
      domElements.mbSearchPreview.innerHTML = "";
    }
  }
})();
